import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { X, Scale, ArrowRight } from 'lucide-react';
import { useCompare } from '@/lib/compareContext';

export function CompareBar() {
  const { compareItems, removeFromCompare, clearCompare } = useCompare();

  if (compareItems.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-stone-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-testid="compare-bar">
      <div className="voltide-container py-3">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 shrink-0">
            <Scale className="w-4 h-4 text-[#0061DD]" />
            <span className="text-sm font-semibold text-[#1A1A1A]">Compare</span>
            <span className="text-xs text-[#A8A29E]">({compareItems.length}/3)</span>
          </div>

          <div className="flex-1 flex items-center gap-2 overflow-x-auto">
            {compareItems.map(p => (
              <div key={p.sku} className="flex items-center gap-2 px-3 py-1.5 bg-stone-50 rounded-full shrink-0">
                <img src={p.image} alt={p.product_name} className="w-6 h-6 object-contain" />
                <span className="text-xs font-medium text-[#1A1A1A] max-w-[120px] truncate">{p.product_name}</span>
                <button
                  onClick={() => removeFromCompare(p.sku)}
                  className="text-[#A8A29E] hover:text-red-500"
                  data-testid={`compare-bar-remove-${p.sku}`}
                >
                  <X className="w-3 h-3" />
                </button>
              </div>
            ))}
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <button onClick={clearCompare} className="text-xs text-[#A8A29E] hover:text-red-500" data-testid="compare-bar-clear">
              Clear
            </button>
            <Link to="/compare">
              <Button className="rounded-full bg-[#0061DD] hover:bg-[#004BB3] text-white text-xs px-5 py-2 gap-1" data-testid="compare-bar-go-btn">
                Compare <ArrowRight className="w-3.5 h-3.5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
